import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { ReferencePatents } from '../reference-patents';
import type { ReferencePatent } from '../../types';
import { PatentProfileRepository } from '../patent-profile-repository';

@injectable()
export class ReferencePatentsImpl implements ReferencePatents {
    constructor(
        @inject(PatentProfileRepository)
        private readonly _patentProfileRepository: PatentProfileRepository,
    ) {}

    async pullReferencePatent(patentNo: string) {
        const result = await this.fetchReferencePatent(patentNo);
        return result;
    }

    async fetchReferencePatent(patentNo: string): Promise<ReferencePatent> {
        const result = await this._patentProfileRepository.getPatentProfileRepository(patentNo);
        return result;
    }
}
